import { SportType, WebsiteSport } from 'store/websiteSports';

export const hasPrematchType = (sport: WebsiteSport) => sport?.types.includes(SportType.premtach);
export const hasLiveType = (sport: WebsiteSport) => sport?.types.includes(SportType.live);
